/* global angular, _, mintel_tracking */

var ngModule = angular.module('trends');

ngModule.directive('pptDownload', ['Api', '$window', 'DownloadManager', 'ModalManager',
    function (Api, $window, DownloadManager, ModalManager) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                scope.downloadPpt = function() {
                    var newScope = angular.extend(scope.$new(), {
                        initialState: 'submit',
                    });

                    ModalManager.create({scope: newScope, template: '/trends/partials/ppt_download/'});
                };

                scope.$on('modal.state', function (evt, args) {
                    var item_id = attrs.pptDownload;
                    if (args.newState === 'submit') {
                        DownloadManager.downloadStaticPpt(item_id).then(function (response) {
                            scope.$broadcast('modal.setstate', 'success');
                            $window.location = response + '?item_id=' + item_id;
                        }, function (error) {
                            if (error.status === 'login_redirect') {
                                $window.location = error.redirect_url +
                                    encodeURIComponent($window.location.pathname + $window.location.hash);
                            }
                            else {
                                var data;
                                if ('errorMessage' in error) {
                                    data = {
                                        'errorMessage': error.errorMessage
                                    };
                                }
                                scope.$broadcast('modal.setstate', error.status, data);
                            }
                        });
                    }
                });
            }
        };
    }
]);

ngModule.directive('pdfDownloadModalLauncher', ['$window', 'DownloadManager', 'ModalManager',
    function ($window, DownloadManager, ModalManager) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var id = parseInt(attrs.pdfDownloadModalLauncher);
                var type = attrs.itemType;
                var title = attrs.itemTitle;
                var date = attrs.itemDate;
                var capsType = type.charAt(0).toUpperCase() + type.slice(1);
                var contentId = attrs.itemId;

                scope.downloadFullPDF = function () {
                    mintel_tracking.download('Content', {
                        'Title': title,
                        'Tags': [],
                        'Author': '',
                        'Display Date': date,
                        'Content Type': capsType,
                        'Content Unique Identifier': contentId,
                        'Slug': '',
                        'Format': '.pdf',
                    });
                    scope.downloadPDF('submit');
                };

                /* This one is not used anymore, may be used again in the future though.*/
                scope.downloadPDF = function (initialState) {
                    var newScope = angular.extend(scope.$new(), {
                        initialState: initialState
                    });

                    ModalManager.create({scope: newScope, template: '/trends/partials/pdf_download/'});
                };

                scope.$on('modal.state', function (evt, args) {
                    if (args.newState === 'submit') {
                        var values = _.pick(args.data.values, _.identity);
                        DownloadManager.downloadPDF(type, id, values).then(function (response) {
                            scope.$broadcast('modal.setstate', 'success');
                            $window.location = response;
                        }, function (error) {
                            if (error.status === 'login_redirect') {
                                $window.location = error.redirect_url +
                                    encodeURIComponent($window.location.pathname + $window.location.hash);
                            }
                            else {
                                var data;
                                if ('errorMessage' in error) {
                                    data = {
                                        'errorMessage': error.errorMessage
                                    };
                                }
                                scope.$broadcast('modal.setstate', error.status, data);
                            }
                        }, function (percentComplete) {
                            scope.$broadcast('modal.setstate', 'progress', {
                                'percentComplete': percentComplete
                            });
                        });
                    }
                });

                scope.initialData = function () {
                    if (type === 'trend') {
                        var options = [
                            {name: 'textcontent', description: 'Text Content'},
                            {name: 'trendobservation', description: 'Trend Observation'},
                            {name: 'dashboard', description: 'Key Information'},
                            {name: 'industryapplication', description: 'Application'}
                        ];

                        return {
                            options: options,
                            values: _.reduce(options, function (result, option) {
                                result[option.name] = true;
                                return result;
                            }, {})
                        };
                    } else {
                        return {};
                    }
                };
            }
        };
    }]);

ngModule.directive('pptbuilderDownloadModalLauncher', ['Api', '$window', 'DownloadManager', 'ModalManager',
    function (Api, $window, DownloadManager, ModalManager) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope) {
                var item_id;

                scope.downloadPptBuilder = function (ppt_id) {
                    var newScope = angular.extend(scope.$new(), {
                        initialState: 'submit',
                    });
                    item_id = ppt_id;

                    ModalManager.create({scope: newScope, template: '/trends/partials/pptbuilder_download/'});
                    mintel_tracking.download('Sidebar', {
                        'Panel': 'My Presentations',
                        'Presentation Title': newScope.ppts[item_id].name,
                        'Number of Slides': newScope.ppts[item_id].item_count,
                        'Format': '.ppt'
                    });
                };

                scope.$on('modal.state', function (evt, args) {
                    if (args.newState === 'submit') {
                        DownloadManager.downloadPptBuilder(item_id).then(function (response) {
                            scope.$broadcast('modal.setstate', 'success');
                            $window.location = response;
                        }, function (error) {
                            var data;
                            if ('errorMessage' in error) {
                                data = {
                                    'errorMessage': error.errorMessage
                                };
                            }

                            scope.$broadcast('modal.setstate', error.status, data);
                        });
                    }
                });
            }
        };
    }
]);
